<template>
  <q-dialog
    v-model="dialog"
    persistent
    class="custom-font text-uppercase"
  >
    <q-card class="pragma-black text-white">
      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-pragma">
          Nueva versión encontrada
        </q-toolbar>
      </q-card-section>
      <q-card-section>
        Por favor, actualice la aplicación a su ultima versión
      </q-card-section>
      <q-card-section>
        <q-btn
          color="green"
          icon="shop"
          label="Ir a la tienda"
          class="full-width"
          @click="goStore()"
          v-if="util.getPlatform() !== 'I'"
        ></q-btn>
        <q-btn
          color="green"
          class="full-width"
          @click="updatePWA()"
          v-if="util.getPlatform() == 'I'"
        >
          <q-img src="assets/apple_icon.svg" style="width: 7%"></q-img>
          <span class="q-pl-sm">Actualizar</span>
        </q-btn>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { inject, ref } from 'vue'
import { useRouter } from 'vue-router'
import util from '../plugins/util'
export default {
  setup () {
    // Variables
    const dialog = ref(false)

    const bus = inject('bus')
    const router = useRouter();

    // Métodos y funciones
    const goStore = () => {
      window.open('https://play.google.com/store/apps/details?id=bo.com.pragmainvest.solicitudes')
    }

    const updatePWA = () => {
      router.go()
    }
    // Creación del componente
    bus.on('showUpdateVersion', () => {
      dialog.value = true
    })
    return {
      dialog,
      goStore,
      updatePWA,
      util
    }
  }
}
</script>

<style>

</style>